import { GET_ONE, CREATE } from 'react-admin';

const dataTripNotes = (res, params, type) => {
  const enhancedResource = Object.assign({}, res);
  const context = params.context || 'BILLING';
  const isOngoingTrip = context === 'ONGOING_TRIP';

  switch (type) {
    case GET_ONE:
      if (isOngoingTrip && res.data && typeof res.data === 'object') {
        if (res.data.content !== undefined) {
          enhancedResource.data = {
            ...res.data,
            id: params.id,
          };
        }
      } else if (res.data && typeof res.data === 'object') {
        if (!res.data.id && params.id) {
          enhancedResource.data.id = params.id;
        }
      }
      break;
    case CREATE: {
      if (res.data && typeof res.data === 'object') {
        if (!res.data.id && params.id) {
          enhancedResource.data.id = params.id;
        }
      }
      break;
    }
    default:
      break;
  }
  return enhancedResource;
};

export default dataTripNotes;
